/**
 * Objeto representando um item do relatório de empresas
 */
class EmpresasItem {

    /**
     * Cria uma nova instância do objeto
     * @param {String} rotulo Rótulo do item do relatório
     * @param {Date} data Data do item do relatório
     * @param {Number} quantidade Quantidade de empresas
     */
    constructor (rotulo, data, quantidade) {
        /** @member {String} rotulo Rótulo do item do relatório */
        this.rotulo = rotulo;
        /** @member {String} data Data do item do relatório */
        this.data = data;
        /** @member {Number} quantidade Quantidade de empresas */
        this.quantidade = quantidade;
    }

    /**
     * Cria uma cópia do objeto
     * @param {EmpresasItem} origem Objeto a ser clonado
     * @return {EmpresasItem} Cópia do objeto original
     */
    static clone(origem) {
        return new EmpresasItem(origem.rotulo, origem.data, origem.quantidade);
    }
}

/**
 * Objeto representando os relatórios de empresas
 */
class Empresas {
    /**
     * Cria uma nova instância do objeto
     * @param {Array<EmpresasItem>} ativas Relatório de empresas ativas por período
     * @param {Array<EmpresasItem>} tipo Relatório de empresas por tipo
     */
    constructor(ativas, tipo) {
        /** @member {Array<EmpresasItem>} ativas Relatório de empresas ativas por período */
        this.ativas = ativas ?? [ ];
        /** @member {Array<EmpresasItem>} tipo Relatório de empresas por tipo */
        this.tipo = tipo ?? [ ];
    }

    /**
     * Cria uma cópia do objeto
     * @param {Empresas} origem Objeto a ser clonado
     * @returns {Empresas} Cópia do objeto original
     */
    static clone(origem) {
        let ativas = [];
        if (origem.ativas)
            ativas = origem.ativas.map(item => EmpresasItem.clone(item));

        let tipo = [];
        if (origem.tipo)
            tipo = origem.tipo.map(item => EmpresasItem.clone(item));
        
        return new Empresas(ativas, tipo);
    }
}

export default Empresas;